import React from 'react';

function Values({ items }) {
  return (
    <section className="py-20 md:py-24 bg-black text-white">
      <div className="container">
        <div className="grid grid-cols-1 lg:grid-cols-3">
          {items?.map(item => (
            <div className="text-center mb-16 lg:mb-0">
              <div className="max-w-[300px] mx-auto">
                <div className="text-secondary-h1 text-135px">{item.heading}</div>
                <div className="text-32px leading-tight mt-3">{item.content}</div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}

export default Values;
